import React from 'react';
import PropTypes from 'prop-types';
import AppActions from '../../actions/app-actions';

// material ui
import ConfigList from './configlist';
import ConfigCreate from './configcreate';
import { preformatWithRequestID } from '../../helpers';
function getState() {
  return {
    pageNo: 1,
    pageLength: 20,
    pageLoading: true
  };
}
const configType = {'all':'all', 'config':'configs', 'flavor':'flavors'};
export default class Configs extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();
    this._handlePageChangeBind = this._handlePageChange.bind(this);
  }

  _getInitialState() {
    return getState();
  }

  componentDidMount() {
    this._getConfigsList(configType.config);
    this._getConfigsCount(configType.config)
  }

  _getConfigsList(conType) {
    var self = this;
    var callback = {
      success: function(configs) {
        self.setState({ configs: configs, pageLoading: false });
      },
      error: function(err) {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'Configurations couldnot be loaded. ' + errormsg
          )
        );
      }
    };
    AppActions.getConfigurations(
      conType,
      callback,
      this.state.pageNo,
      this.state.pageLength,
      this.state.selectedGroup
    );
  }

  _getConfigsCount(conType) {
    var self = this;
    var callback = {
      success: function(count) {
        console.log()
        self.setState({ count: count });
      },
      error: function(err) {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'Configurations couldnot be loaded. ' + errormsg
          )
        );
      }
    };
    AppActions.getConfigurationCount(
      conType,
      callback,
    );
  }

  _handlePageChange(pageNo) {
    this.setState({pageLoading: true, selectedRows: [], pageNo}, () => {
      this._getConfigsList(configType.config);
    });
  }

  _editSubmit = (configData) => {
    var self = this;
    var callback = {
      success: function() {
        AppActions.setSnackbar('The Configuration has been updated.');
        self._getConfigsList(configType.config);
      },
      error: function(err) {
        console.log(err);
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'There was an error editing the Configuration. ' + errMsg
          )
        );
      }
    };
    AppActions.editConfiguration(configType.config, configData.id, JSON.stringify(configData), callback);
  }

  _createSubmit = (configData) => {
    var self = this;
    var callback = {
      success: function() {
        AppActions.setSnackbar('The Configuration was created successfully.');
        self._getConfigsList(configType.config);
      },
      error: function(err) {
        console.log(err);
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'There was an error creating the Configuration. ' + errMsg
          )
        );
      }
    };

    AppActions.createConfiguration(configType.config, configData, callback);
  }

  _removeSubmit = (configData) => {
    var self = this;
    var callback = {
      success: function() {
        AppActions.setSnackbar(
          'The Configuration was removed from the system.'
        );
        self._getConfigsList(configType.config);
      },
      error: function(err) {
        console.log(err);
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'There was an error removing the config. ' + errMsg
          )
        );
      }
    };
    AppActions.deleteConfiguration(configType.config, configData.id, callback);
  }

  render() {
    return (
      <div>
        <div className="float-right">
          <ConfigCreate
            edit={this.state.config ? true : false}
            handleSubmit={
              this.state.config ? this._editSubmit : this._createSubmit
            }
            config={this.state.config}
            type={'configs'}
            buttonLabel={'Create Config'}
          />
        </div>
        <ConfigList
          configs={this.state.configs || []}
          handleSubmit={this._editSubmit}
          handleRemove={this._removeSubmit}
          onPageChange={this._handlePageChangeBind}
          pageTotal={this.state.count}
          pageNo={this.state.pageNo}
          pageLength={this.state.pageLength}
          pageLoading={this.state.pageLoading}
          type={'configs'}
        />
      </div>
    );
  }
}
